export default {"src":"/_next/static/media/zokyo.f8e73561.svg","height":28,"width":86,"blurWidth":0,"blurHeight":0};